// frontend/src/components/ContactSection.js
import React, { useState, useRef, useEffect } from 'react';
import './ContactSection.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

// Importing Font Awesome icons (ensure you have Font Awesome setup in your project's public/index.html)
// e.g., <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" />
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa'; // Using react-icons directly

const ContactSection = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [submissionMessage, setSubmissionMessage] = useState(null); // { type: 'success' | 'error', text: '...' }
    const messageTimeoutRef = useRef(null); // Ref to store the timeout ID

    const [sectionRef, isSectionVisible] = useScrollAnimation(0.1);

    // Clear message after a few seconds
    useEffect(() => {
        if (submissionMessage) {
            messageTimeoutRef.current = setTimeout(() => {
                setSubmissionMessage(null);
            }, 5000); // Message disappears after 5 seconds
        }
        return () => {
            if (messageTimeoutRef.current) {
                clearTimeout(messageTimeoutRef.current);
            }
        };
    }, [submissionMessage]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmissionMessage(null); // Clear previous message

        // --- REAL APPLICATION LOGIC ---
        try {
            // FIX: Use the environment variable to get the base URL
            const apiBaseUrl = process.env.REACT_APP_API_URL || 'https://greenpod-project-backend.onrender.com'; 
            
            const response = await fetch(`${apiBaseUrl}/api/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) { // Check if the response status is 200-299
                setSubmissionMessage({ type: 'success', text: 'Thank you for your message! We will get back to you soon.' });
                setFormData({ name: '', email: '', message: '' }); // Clear form
            } else {
                const errorData = await response.json(); // Attempt to get error message from backend
                setSubmissionMessage({ type: 'error', text: errorData.message || 'Failed to send message. Please try again later.' });
            }
        } catch (error) {
            console.error('Submission error:', error);
            setSubmissionMessage({ type: 'error', text: 'Network error. Please check your connection and try again.' });
        }
    };

    // --- NEW: Owner name and address data ---
    // IMPORTANT: Replace this with the actual owner's name and full address
     
    const fullAddress = "45 London Road, Santina Apartment";
    const mapLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`;
    const phoneNumber = "+44 7436 592175";
    const whatsappMessage = "Hello, I have a question about your spices.";
    const whatsappLink = `https://wa.me/${phoneNumber.replace(/\s/g, '')}?text=${encodeURIComponent(whatsappMessage)}`;

    return (
        <section id="contact-section" className="contact-section" ref={sectionRef}>
            <h2 className="section-titlee">Contact Us</h2>
            <div className={`contact-content ${isSectionVisible ? 'show' : ''}`}>
                <div className="contact-info">
                    <h3>Get in Touch</h3>
                    {/* NEW: Display the owner's name */}
                   
                    <p>Have a question about our spices, gifting options, or bulk partnerships?
We’re always happy to connect and help bring authentic Kerala flavours to your hand.</p>
                    <div className="info-item">
                        <FaMapMarkerAlt className="icon" /> {/* Using react-icons */}
                        {/* MODIFIED: The address is now a clickable link to a map */}
                        <a href={mapLink} target="_blank" rel="noopener noreferrer" className="address-link">
                            {fullAddress}
                        </a>
                    </div>
                    {/* MODIFIED: Phone number is now a clickable link to a WhatsApp chat */}
                    <div className="info-item">
                        <FaPhone className="icon" /> {/* Using react-icons */}
                        <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="contact-phone-link">
                            {phoneNumber}
                        </a>
                    </div>
                    {/* FIX: Replaced the <p> tag with a clickable <a> tag */}
                    <div className="info-item">
                        <FaEnvelope className="icon" /> {/* Using react-icons */}
                        <a href="mailto:thegreenpod.spices@gmail.com" className="contact-email-link">
                            thegreenpod.spices@gmail.com
                        </a>
                    </div>
                </div>

                <div className="contact-form-container">
                    <h3>Send Us a Message</h3>
                    <form className="contact-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="name">Your Name</label>
                            <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Your Email</label>
                            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
                            <small className="email-clarification">
                                Please enter your email address so we can reply to you.
                            </small>
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">Your Message</label>
                            <textarea id="message" name="message" rows="6" value={formData.message} onChange={handleChange} required></textarea>
                        </div>
                        <button type="submit" className="submit-button">Send Message</button>

                        {/* Submission Message Display */}
                        {submissionMessage && (
                            <div className={`submission-message ${submissionMessage.type}`}>
                                {submissionMessage.text}
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;
